import { render, staticRenderFns } from "./sorundestekislem.vue?vue&type=template&id=a0dda6de&"
import script from "./sorundestekislem.vue?vue&type=script&lang=js&"
export * from "./sorundestekislem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports